import type { AccountDataOrganization } from '~/api/gen'

// Données mock pour GET /account/organizations.
// L'`id` PRINCIPAL doit rester OFFI0000011616 pour rester cohérent avec les
// office_oid des annonces mock (cf. msw/mocks/diffusion/annoncesDiffusion.ts).
export const organizations: AccountDataOrganization[] = [
  {
    id: 'OFFI0000011616',
    name: 'Office Notarial de Toulouse',
    crpcen: '11616',
    codeNs: '0000011616',
    type: 'PRINCIPAL',
  },
]
